import React from "react";
import pluralize from "pluralize";
import useMeasure from "react-use-measure";

import { useSpring, animated } from "@react-spring/web";
import AssetShare from "../assetShare";
import { AssetShareLoader } from "src/pages/conversations/components/loaders";

import _ from "lodash";
import cx from "classnames";
import styles from "./sectionShare.module.scss";
interface ISectionShare {
  section: any;
  fetchAssetsForSection: (sectionId: string) => void;
  fetchAnalytics: (assetId: string, sectionId?: string) => void;
  source: 'contact' | 'conversation';
  shareId?: string;
}
export const SectionShare: React.FC<ISectionShare> = ({
  section,
  fetchAssetsForSection,
  fetchAnalytics,
  source,
  shareId

}) => {
  //state
  const [mountChildren, setMountChildren] = React.useState(false);

  //constants
  const [containerRef, containerBounds] = useMeasure();
  const [childrenAnimation] = useSpring(
    {
      opacity: mountChildren ? 1 : 0,
      height: mountChildren ? containerBounds.height : 0,
      from: { opacity: 0, height: 0 },
    },
    [mountChildren, containerBounds],
  );

  //functions
  const fetchAssetAnalyticsForSections = (assetId: string) => {
    fetchAnalytics(assetId, section.id);
  };
  const fetchChildren = () => {
    setMountChildren(!mountChildren);
    if (_.size(section.assets) === 0) {
      fetchAssetsForSection(section.id);
    }
  };

  //render
  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <div className={cx(styles.title,{
            [styles.open]: mountChildren,
          })} onClick={fetchChildren}>
          <p>{section.name}</p>
          <i className="paperflite-dropdown" />
        </div>

        <p className={styles.subTitle}>
          <strong>{section.assetsCount}</strong>{" "}
          {pluralize("asset", section.assetsCount)}
          {source === "conversation" && (
            <span className={cx(styles.subTitle, styles.viewCount)}>
              <strong>{section.assetViewedCount || 0}</strong>{" "}
              {_.get(section, "assetViewedCount") === 1 ? "asset viewed" : "assets viewed"}
            </span>
          )}
        </p>
      </div>

      <animated.div style={childrenAnimation}>
        {mountChildren && (
          <div ref={containerRef} className={styles.children}>
            {_.get(section, "loading", false) && <AssetShareLoader count={3} />}
            {_.get(section, "loaded") &&
              _.size(section.assets) > 0 &&
              section.assets?.map((asset) => {
                return (
                  <AssetShare
                    key={asset.id}
                    asset={asset}
                    shareId={shareId}
                    source={source}
                    sectionId={section.id}
                    fetchAnalytics={fetchAssetAnalyticsForSections}
                  />
                );
              })
            }
            {_.get(section, "loaded") && _.size(section.assets) === 0 && (
              <div className={styles.noRecords}>
                <p>No records found</p>
              </div>
            )}
          </div>
        )}
      </animated.div>
    </div>
  );
};
